var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"icon",class:_vm.className,on:{"click":function($event){$event.stopPropagation();return _vm.handleClick.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }